import React, { useMemo, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";

import { Separator, ButtonWithDropdown } from "../../components";
import MoneyRange from "../../components/formatters/MoneyRange";
import ItemDetail from "./ItemDetail";
import { getFileUrl } from "../../core/config/api.js";
import { getBaseCurrency } from "../../core/currency";
import AlertHelper from "../../helpers/Alert";

const AlertItem = ({ alert, handleItemUpdate }) => {
  const history = useHistory();
  const [status, setStatus] = useState(alert.status);
  const [alertStatus, setAlertStatus] = useState(alert.alert);
  const [expanded, setExpanded] = useState(false);

  const switchProps = {
    checkedIcon: false,
    uncheckedIcon: false,
    offHandleColor: "#000",
    offColor: "#dc3545",
    onColor: "#198754",
    height: 21,
    width: 41,
    handleDiameter: 16,
  };

  const onEditClick = () => {
    history.push(`/alerts/${alert.id}/edit`);
  };

  const onDeleteClick = async () => {
    const response = await axios.delete(`/api/buy-alerts/${alert.id}`);
    handleItemUpdate();
  };

  const editButtonProps = {
    label: "Edit",
    onClick: onEditClick,
    options: [
      {
        label: "Delete",
        onClick: onDeleteClick,
      },
    ],
  };

  const onSyncStatus = (status) => {
    setStatus(status);

    axios.patch(`/api/buy-alerts/${alert.id}/status`, {
      status,
    });
  };

  const onSyncAlertStatus = (alertStatus) => {
    setAlertStatus(alertStatus);

    axios.patch(`/api/buy-alerts/${alert.id}/alert`, {
      alert: alertStatus,
    });
  };

  const yearLabel = useMemo(
    () => AlertHelper.getYearRangeLabel(alert.years),
    [alert.years]
  );

  const onItemClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <div className="listing-details-row col-12 p-2 p-lg-4 ps-lg-5">
        <div className="d-lg-flex justify-content-between">
          <div className="d-lg-none">
            <Separator noMargin className="mt-2 mb-2" />
          </div>

          <div className="d-flex flex-grow-1" onClick={onItemClick}>
            <div className="image ps-5 ps-lg-0 pt-2 pt-lg-0">
              {!alert.is_not_product && alert.product?.images.length > 0 ? (
                <img src={getFileUrl(alert.product?.images[0].id)} />
              ) : (
                <img src="/assets/icons/alert-watch.png" />
              )}
            </div>

            <div className="details ps-5 ps-lg-4 pt-2">
              <h3 className="d-flex align-items-center ">
                {alert.product.brand.name} {alert.product.model.name}
                {alert.underpriced && (
                  <img src="/assets/icons/diamond.svg" className="ms-2 mb-1" />
                )}
              </h3>
              <MoneyRange
                start={alert.min_price}
                end={alert.max_price}
                // Buy-alert budgets carry no per-record currency — deliberate store-base render.
                currency={alert.currency ?? getBaseCurrency()}
                className="price"
              />
              <strong>
                {yearLabel}
                <br />
              </strong>
              {!alert.is_not_product && <span>{alert.reference_number}</span>}
            </div>
          </div>

          <div className="d-lg-none">
            <Separator noMargin className="mt-2 mb-2" />
          </div>

          <div className="d-none flex-column justify-content-between switch-container pe-4 d-lg-flex">
            <div className="switches mt-2">
              <div className="switch d-flex justify-content-start">
                <label className="align-self-center">
                  {status ? "ON" : "OFF"}
                </label>

                <Switch
                  onChange={(val) => onSyncStatus(val)}
                  checked={!!status}
                  {...switchProps}
                />
              </div>
              <div className="switch d-flex justify-content-start">
                <label className="align-self-center">ALERT</label>

                <Switch
                  onChange={(val) => onSyncAlertStatus(val)}
                  checked={!!alertStatus}
                  {...switchProps}
                />
              </div>
            </div>
          </div>

          <div className="d-none d-lg-flex flex-column justify-content-between">
            <div className="d-flex justify-content-start justify-content-lg-end mb-2 ms-4 mt-5">
              <ButtonWithDropdown {...editButtonProps} />
            </div>
            <div className="d-flex justify-content-start justify-content-between mb-2">
              <div className="text-center ms-5">Alert Id : {alert.id}</div>
            </div>
          </div>
        </div>
      </div>
      {expanded && <ItemDetail alertId={alert.id} />}
    </>
  );
};
export default AlertItem;
